/* expviews */

import React, { useState, useEffect } from 'react'
import { firebaseDb } from '../../config/firebaseConfig'
import firebase from 'firebase'

import { Container, Grid } from '@material-ui/core'

//COMPONENTS
import ExperienceComponent from '../../components/ExperienceComponent/ExperienceComponent'
import { getSettingsAgency } from '../../services/FirebaseServices/agencyServices'

const ExperienceView = ({ agency, experiencesData }) => {
  const [settings, setSettings] = useState({})
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const settingsResponse = await firebaseDb
      .collection('agency')
      .doc(agency.key)
      .collection('settings')
      .get()
    const data = []
    settingsResponse.forEach((r) => {
      data.push(r.data())
    })
    setSettings(data)
  }

  const handleCategoryArray = (category) => {
    switch (category) {
      case 'AGENCY':
        return experiencesData.filter(
          (exp) => exp.category === category && exp.isActive === true,
        )
      case 'HOTEL':
        return experiencesData.filter(
          (exp) => exp.category === category && exp.isActive === true,
        )
      case 'PROGRAM':
        return experiencesData.filter(
          (exp) => exp.category === category && exp.isActive === true,
        )

      case 'RESTAURANT':
        return experiencesData.filter(
          (exp) => exp.category === category && exp.isActive === true,
        )
      case 'ECOMMERCE':
        return experiencesData.filter(
          (exp) => exp.category === category && exp.isActive === true,
        )

      default:
        return experiencesData
    }
  }
  const getExperiencesModel = () => {
    // if (!!agency.settings) {
    //   if (!!agency.settings.experiencesModel) {
    //     return agency.settings.experiencesModel
    //   } else {
    //     return agency.settings.banner.experiencesModel
    //   }
    // } else {
    //   return 1
    // }

    return 1
  }

  return settings.length > 0 && false ? (
    <Container>
      {settings.map((exp) => (
        <>
          <h1 style={{ color: '#673AB7' }}>{exp.name}</h1>
          <Grid container spacing={3}>
            {exp.experiences
              .filter((x) => x.checked)
              .map((experience) => (
                <Grid item xs={12} sm={6} md={4} key={exp.key}>
                  <ExperienceComponent
                    slugAgency={agency.agencyUrl}
                    experience={experience}
                    experiencesData={experiencesData}
                    experiencesModel={getExperiencesModel()}
                  />
                </Grid>
              ))}
          </Grid>
        </>
      ))}
    </Container>
  ) : (
    <Container>
      {handleCategoryArray('AGENCY').length > 0 && (
        <>
          <h1 style={{ color: '#673AB7' }}>
            Experiencia turística, agroturismo y turismo aventura
          </h1>
          <Grid container spacing={3}>
            {handleCategoryArray('AGENCY').map((exp) => (
              <Grid item xs={12} sm={6} md={4} key={exp.key}>
                <ExperienceComponent
                  slugAgency={agency.agencyUrl}
                  experience={exp}
                  experiencesData={experiencesData}
                  experiencesModel={getExperiencesModel()}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}

      {handleCategoryArray('HOTEL').length > 0 && (
        <>
          <h1 style={{ color: '#673AB7', marginTop: '55px' }}>
            Hoteles, hostales y alojamientos
          </h1>
          <Grid container spacing={3}>
            {handleCategoryArray('HOTEL').map((exp) => (
              <Grid item xs={12} sm={6} md={4} key={exp.key}>
                <ExperienceComponent
                  slugAgency={agency.agencyUrl}
                  experience={exp}
                  experiencesData={experiencesData}
                  experiencesModel={getExperiencesModel()}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}

      {handleCategoryArray('PROGRAM').length > 0 && (
        <>
          <h1 style={{ color: '#673AB7', marginTop: '55px' }}>Programas</h1>
          <Grid container spacing={3}>
            {handleCategoryArray('PROGRAM').map((exp) => (
              <Grid item xs={12} sm={6} md={4} key={exp.key}>
                <ExperienceComponent
                  slugAgency={agency.agencyUrl}
                  experience={exp}
                  experiencesData={experiencesData}
                  experiencesModel={getExperiencesModel()}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}

      {handleCategoryArray('RESTAURANT').length > 0 && (
        <>
          <h1 style={{ color: '#673AB7', marginTop: '55px' }}>
            Bar, restaurant y café
          </h1>
          <Grid container spacing={3}>
            {handleCategoryArray('RESTAURANT').map((exp) => (
              <Grid item xs={12} sm={6} md={4} key={exp.key}>
                <ExperienceComponent
                  slugAgency={agency.agencyUrl}
                  experience={exp}
                  experiencesData={experiencesData}
                  experiencesModel={getExperiencesModel()}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}

      {handleCategoryArray('ECOMMERCE').length > 0 && (
        <>
          <h1 style={{ color: '#673AB7', marginTop: '55px' }}>
            Tiendas Online
          </h1>
          <Grid container spacing={3}>
            {handleCategoryArray('ECOMMERCE').map((exp) => (
              <Grid item xs={12} sm={6} md={4} key={exp.key}>
                <ExperienceComponent
                  slugAgency={agency.agencyUrl}
                  experience={exp}
                  experiencesData={experiencesData}
                  experiencesModel={getExperiencesModel()}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Container>
  )
}

export default ExperienceView
